import { axios, createFormData, handleError } from '../axios';

export const memberAuth = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post('member/account/auth', createFormData(data ? data : {}))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
